export default __webpack_public_path__ + "navigation-examples-offline-regions-thumbnail-480-b74233a5c9dbc18bf5d19eed26945a1f.webp";